<template>
	<div
		v-for="item in items"
		:key="`previewFuel-${item.id}`"
		class="d-flex my-3"
	>
		<ao-groupbox custom="preview">
			<div class="d-flex">
				<span
					v-if="item.name"
					class="ao-p1 text-textBody mb-2"
				>
					{{ item.name }}
				</span>
				<v-spacer />

				<slot
					name="checkbox"
					:item="item"
				></slot>
				<!-- <ao-checkbox /> -->
				<slot
					name="actions"
					:item="item"
				>
					<div v-if="type === true && hasOwnFinanceAttribution === false"></div>
					<ao-icon-btn
						v-else
						variant="plain"
						size="18"
						iconName="pen"
						class="mr-1"
						@click="$emit('edit', item.id)"
					/>
					<ao-icon-btn
						v-if="addingButton"
						variant="plain"
						size="18"
						iconName="plus"
						class="mr-1"
						@click="$emit('add', item.id)"
					/>
					<ao-icon-btn
						variant="plain"
						v-if="type === false || item.is_base === false || item.is_main === false"
						size="18"
						iconName="delete"
						@click="$emit('delete', item.id)"
					/>
				</slot>
			</div>
			<div
				class="d-flex"
				:class="{ 'flex-column': vertical }"
			>
				<slot
					name="params"
					:item="item"
				>
					<div
						v-for="param in item.params"
						:class="Array.isArray(param) ? 'mr-4 d-flex' : 'mr-4'"
					>
						<div
							v-if="Array.isArray(param)"
							v-for="elem in param"
							class="mr-4"
						>
							<div>
								<span class="ao-p2-regular text-textSecondary700 mr-1">{{ elem.key }}</span>
								<span class="ao-p2-medium text-textBody">{{ elem.value }}</span>
							</div>
						</div>
						<div v-else>
							<span class="ao-p2-regular text-textSecondary700 mr-1">{{ param.key }}</span>
							<span class="ao-p2-medium text-textBody">{{ param.value }}</span>
						</div>
					</div>
				</slot>

				<div class="ao-p1 mt-4">
					{{ item.itemsName }}
				</div>

				<div
					v-if="item.items"
					v-for="elem in item.items"
				>
					<ao-groupbox custom="preview">
						<div class="d-flex">
							<span
								v-if="elem.name"
								class="ao-p3 text-textBody mb-2"
							>
								{{ elem.name }}
							</span>
							<v-spacer />

							<slot
								name="checkbox"
								:item="item"
							></slot>
							<!-- <ao-checkbox /> -->
							<slot
								name="actions"
								:item="elem"
							>
								<ao-icon-btn
									variant="plain"
									size="18"
									iconName="pen"
									class="mr-1"
									@click="$emit('editItem', item.id, elem.id)"
								/>
								<ao-icon-btn
									variant="plain"
									size="18"
									iconName="delete"
									@click="$emit('deleteItem', item.id, elem.id)"
								/>
							</slot>
						</div>
						<div
							class="d-flex"
							:class="{ 'flex-column': vertical }"
						>
							<slot
								name="params"
								:item="elem"
							>
								<div
									v-for="param in elem.params"
									:class="Array.isArray(param) ? 'mr-4 d-flex' : 'mr-4'"
								>
									<div
										v-if="Array.isArray(param)"
										v-for="elem in param"
										class="mr-4"
									>
										<div>
											<span class="ao-p3-regular text-textSecondary700 mr-1">{{ elem.key }}</span>
											<span class="ao-p3-medium text-textBody">{{ elem.value }}</span>
										</div>
									</div>
									<div v-else>
										<span class="ao-p3-regular text-textSecondary700 mr-1">{{ param.key }}</span>
										<span class="ao-p3-medium text-textBody">{{ param.value }}</span>
									</div>
								</div>
							</slot>
						</div>
					</ao-groupbox>
				</div>
			</div>
			<!-- <span class="ao-p2-regular text-textSecondary700 w-50" >{{item.key}}</span>
			<span class="ao-p2-medium text-textBody w-50" >{{item.text}}</span> -->
		</ao-groupbox>
	</div>
</template>

<script>
export default {
	name: 'FormsMicroform',
	props: {
		items: {
			type: Array, // [{id, name, is_base, is_main, params:[key,value]}]
		},
		vertical: {
			type: Boolean,
		},
		type: {
			type: Boolean,
			default: false,
		},
		hasOwnFinanceAttribution: {
			type: Boolean,
			default: false,
		},
		addingButton: {
			type: Boolean,
			default: false,
		},
	},
	emits: ['edit', 'delete'],
	data() {
		return {
			checked: false,
		}
	},
}
</script>

<style lang="scss"></style>
